import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import type { CardFooterProps } from "./types";

export const CardFooter = ({ className, testID, children }: CardFooterProps) => (
  <Box
    className={cn("gap-spacing-sm flex flex-row items-center", className)}
    {...platformProps({ testID, slot: "card-footer" })}
  >
    {children}
  </Box>
);

CardFooter.displayName = "Card.Footer";
